module.exports = __webpack_public_path__ + "static/media/DeliveryTime.c33cbb49.zip";